/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, OperaSecondaria } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalOperaSecondariaComponent } from '../modal-opera-secondaria/modal-opera-secondaria.component';

@Component({
    selector: 'app-toolkit-opera-tab-opere-secondarie',
    templateUrl: './tab-opere-secondarie.component.html',
})
export class ToolkitGestioneOperaTabOpereSecondarieComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() items: OperaSecondaria[] = [];
    @Input() datalist: DatalistAnagrafica;

    constructor(
        private modalService: NgbModal,
        private operaService: OperaService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.operaService.operaSecondariaByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: OperaSecondaria[]) => {
            this.items = list;
        });
    }
    public viewItem(item: OperaSecondaria) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalOperaSecondariaComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Visualizza';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = item;
        modal.componentInstance.canEdit = false;
    }
    
    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalOperaSecondariaComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.insertOperaSecondaria(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.operaSecondariaByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: OperaSecondaria[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(operaSecondaria: OperaSecondaria) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalOperaSecondariaComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = operaSecondaria;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.updateOperaSecondaria(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.operaSecondariaByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: OperaSecondaria[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idOperaSecondaria: number) {
        this.operaService.deleteOperaSecondaria(idOperaSecondaria).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.operaService.operaSecondariaByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: OperaSecondaria[]) => {
                    this.items = list;
                });
            }
        });
    }

}
